import './../styles/components/skeleton.css';

export function HeroSkeleton() {
  return (
    <div class="sk-hero">
      <div class="sk-bar sk-w-200 sk-h-12" />
      <div class="sk-bar sk-w-500 sk-h-80" />
      <div class="sk-bar sk-w-300 sk-h-16" />
    </div>
  );
}

export function GridSkeleton() {
  return (
    <div class="sk-grid">
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} class="sk-card" />
      ))}
    </div>
  );
}
